import React, { useEffect, useState } from "react";
import { httpReauest } from "../../utils/httpRequest";
import { Link } from "react-router-dom";

const Footer = () => {
  const [data, setData] = useState();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    await httpReauest("GET", `/data`, {}, {}).then(({ data }) => {
      setData(data?.data[0]);
    });
  }
  return (
    <div className="w-full flex justify-center relative mt-10 lg:mt-5 my-5 line-x container_1">
      <div className="grid grid-cols-5 gap-3">
        <Link
          target="_blank"
          to={data?.instagram}
          className="border-brand flex justify-center items-center p-3"
        >
          <img src="/instagram.png" className="w-[25px]" alt="instagram" />
        </Link>
        <Link
          target="_blank"
          to={data?.aparat}
          className="border-brand flex justify-center items-center p-3"
        >
          <img src="/aparat.svg" className="w-[25px] opacity-65" alt="aparat" />
        </Link>
        <Link
          target="_blank"
          to={data?.telegram}
          className="border-brand flex justify-center items-center p-3"
        >
          <img
            src="/la_telegram.png"
            className="w-[25px] opacity-65"
            alt="telegram"
          />
        </Link>
        <Link
          target="_blank"
          to={data?.whatsapp}
          className="border-brand flex justify-center items-center p-3"
        >
          <img
            src="/whatsapp.png"
            className="w-[25px] opacity-65"
            alt="whatsapp"
          />
        </Link>
        <Link
          target="_blank"
          to={data?.ita}
          className="border-brand flex justify-center items-center p-3"
        >
          <img src="/ita.webp" className="w-[25px] " alt="ita" />
        </Link>
      </div>
    </div>
  );
};

export default Footer;
